class FlavorSlider extends HTMLElement {
  connectedCallback() {
    const main = this.querySelector('.flavor-slider__main');
    const thumbsWrap = this.querySelector('.flavor-slider__thumbs');
    if (!main || !thumbsWrap) return;

    const slides = [...main.querySelectorAll('.flavor-slide')];
    const thumbs = [...thumbsWrap.querySelectorAll('.flavor-thumb')];
    if (!slides.length) return;

    let current = 0;

    const setActive = (i, scroll = true) => {
      current = Math.max(0, Math.min(i, slides.length - 1));
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === current));
      if (scroll) thumbs[current]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    const goTo = (i) => {
      const idx = (i + slides.length) % slides.length;
      main.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      setActive(idx)
    };

    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        const idx = parseInt(t.dataset.index, 10);
        if (!isNaN(idx)) goTo(idx);
      });
    });

    this.querySelector('.flavor-slider__nav--prev')?.addEventListener('click', () => goTo(current - 1));
    this.querySelector('.flavor-slider__nav--next')?.addEventListener('click', () => goTo(current + 1));

    let scrollTimer;
    main.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const w = main.clientWidth;
        if (!w) return;
        const idx = Math.round(main.scrollLeft / w);
        if (idx !== current) setActive(idx);
      }, 80);
    }, { passive: true });

    setActive(0, false);
  }
}

customElements.define('ako-flavor-slider', FlavorSlider);
